import { RcThemeInput } from '@ringcentral/juno';
import { overridesFactory } from '@/shared/theme/utils/overrides.factory';
import { paletteFactory } from '@/shared/theme/utils/palette.factory';

export const avayaPrimaryColor = '#575759';
export const avayaSecondaryColor = '#DA291C';

export const avayaTheme: RcThemeInput = {
  palette: paletteFactory(avayaPrimaryColor, avayaSecondaryColor),
  overrides: overridesFactory(avayaPrimaryColor),
};
